import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Student } from './student.model';
import { DateUtils } from 'ng-jhipster';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

@Injectable()
export class StudentService extends AbstractEntityService {

    protected resourceUrl = 'api/students';
    private resourceSearchUrl = 'api/_search/students';
    protected resourceCountUrl = 'api/_search/count/students';
    private resourceCurrentUrl = 'api/students/current';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(student: Student): Observable<Student> {
        let copy: Student = Object.assign({}, student);
        copy.dateOfBirth = this.dateUtils
            .convertLocalDateToServer(student.dateOfBirth);
        return this.http.post<HttpResponse<Student>>(this.resourceUrl, copy).map((res: HttpResponse<Student>) => {
            return res;
        });
    }

    update(student: Student): Observable<Student> {
        let copy: Student = Object.assign({}, student);
        copy.dateOfBirth = this.dateUtils
            .convertLocalDateToServer(student.dateOfBirth);
        return this.http.put<HttpResponse<Student>>(this.resourceUrl, copy).map((res: HttpResponse<Student>) => {
            return res;
        });
    }

    find(id: number): Observable<Student> {
        return this.http.get<HttpResponse<Student>>(`${this.resourceUrl}/${id}`).map((res: HttpResponse<Student>) => {
            let jsonResponse: Student = res;
            jsonResponse.dateOfBirth = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.dateOfBirth);
            return jsonResponse;
        });
    }

    query(req?: any, extended?: boolean): Observable<HttpResponse<Student[]>> {
       let options = this.createRequestOption(req, extended);
        return this.http.get<HttpResponse<Student[]>>(this.resourceUrl, options)
            .map((res: HttpResponse<Student[]>) => this.convertResponse(res));
    }

    search(req?: any, extended?: boolean): Observable<HttpResponse<Student[]>> {
        let options = this.createRequestOption(req, extended);
        return this.http.get<HttpResponse<Student[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<Student[]>) => this.convertResponse(res));
    }

    getCurrent(): Observable<HttpResponse<Student>> {
        return this.http.get<HttpResponse<Student>>(this.resourceCurrentUrl, {
            headers: {
                Prefer: 'return=representation',
                Vary : 'Prefer,Accept,Accept-Encoding'
            }
        })
        .map((res: HttpResponse<Student>) => {
            return this.convertSingleResponse(res);
        });
    }

    updateCurrent(student: Student): Observable<Student> {
        let copy: Student = Object.assign({}, student);
        copy.dateOfBirth = this.dateUtils.convertLocalDateToServer(student.dateOfBirth);
        return this.http.put<HttpResponse<Student>>(this.resourceCurrentUrl, copy)
                        .map((res: HttpResponse<Student>) => {
                            return res;
                        });
    }

    private convertResponse(res: HttpResponse<Student[]>): any {
        let jsonResponse: Student[] = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i] = this.convertSingleResponse(jsonResponse[i]);
        }
        return res.clone({body: jsonResponse});
    }

    private convertSingleResponse(jsonRes: any): any {
        let finalJsonRes = Object.assign({}, jsonRes);
        finalJsonRes.dateOfBirth = this.dateUtils.convertLocalDateFromServer(finalJsonRes.dateOfBirth);
        if (finalJsonRes.status) {
        // Calculate the financial status of the student
            finalJsonRes.paidPercentage = finalJsonRes.status.total
                ? Math.trunc((finalJsonRes.status.totalPaid * 100) / finalJsonRes.status.total)
                : 100;
        }
        return finalJsonRes;
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student/student.service.ts